import React from 'react';
import { MLS_BUCKET_META } from './rollupConfig';

// MLS-UNIFIED-STATUS-001 — compact "MLS: [status] | TAX: [status]" badges for
// dual orders in the MLS Operations view. Statuses come from the backend's
// read-time derivation (`order.mls_status`), never recomputed here.
const meta = (s) => MLS_BUCKET_META[s] || { label: s || '—', cls: 'bg-slate-100 text-slate-600 border-slate-200' };

const Pill = ({ comp, status, orderId }) => {
  const m = meta(status);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[11px] leading-none whitespace-nowrap ${m.cls}`}
      data-testid={`mls-status-${comp}-${orderId}`}
      data-status={status}
      title={`${comp === 'tax' ? 'Tax Search' : 'MLS Search'}: ${m.label}`}
    >
      <span className="font-bold tracking-wider text-[9px] opacity-80">{comp === 'tax' ? 'TAX:' : 'MLS:'}</span>
      <span className="font-medium">{m.label}</span>
    </span>
  );
};

const ORDER_LEVEL_LABELS = {
  open: 'Open', in_progress: 'In Progress', processing: 'In Progress', pending: 'Pending',
  mail_away: 'Mail-Away', mailaway: 'Mail-Away', mail_away_received: 'Mail-Away Received',
  clarification: 'Clarification', clarification_received: 'Clarification Received',
  qc_review: 'QC Review', pending_correction: 'Correction Required', complete: 'Complete', cancelled: 'Cancelled',
};

export default function MlsDualStatusBadges({ order, showOrderLevelHint = false }) {
  const ms = order?.mls_status;
  if (!ms) return null;
  const orderLevel = ['qc_review', 'pending_correction'].includes(order.status) ? order.status : null;
  const hint = showOrderLevelHint
    ? `Order-level status: ${ORDER_LEVEL_LABELS[order.status] || order.status || '—'}`
    : undefined;
  return (
    <div
      className="flex flex-col gap-1"
      data-testid={`mls-dual-status-${order.id}`}
      data-bucket={ms.bucket}
      data-order-status={order.status}
      title={hint}
    >
      {orderLevel && (
        <span
          className={`inline-flex w-fit items-center rounded border px-1.5 py-0.5 text-[11px] font-semibold leading-none ${meta(orderLevel).cls}`}
          data-testid={`mls-order-level-status-${order.id}`}
        >
          {meta(orderLevel).label}
        </span>
      )}
      <div className="flex flex-col items-start gap-0.5">
        <Pill comp="mls" status={ms.mls} orderId={order.id} />
        <Pill comp="tax" status={ms.tax} orderId={order.id} />
      </div>
    </div>
  );
}
